
import React, { useCallback, useEffect, useRef, useState } from 'react';
import StarRating from '@/components/ui/StarRating';
import { AnimatedSection } from '@/hooks/useScrollAnimation';
import useEmblaCarousel from 'embla-carousel-react';

const testimonials: { id: string; name: string; source: string; text: string }[] = [
  { id: '7', name: 'R.S.', source: 'Paciente', text: 'Parabéns pelo seu dia! Um excelente profissional, um excelente cirurgião plástico. Além de ser ótimo médico, é detalhista, competente e tem um grande diferencial: além de toda sua técnica, nunca vi um médico com tanta empatia com seus pacientes. Não adianta dominar todas as fases e todas as técnicas, é preciso também ser um bom ser humano, tratar com respeito, carinho e empatia — esse é o seu diferencial. Eu te admiro muito. Parabéns! Brilhe, brilhe muito, porque você merece 👏👏. Parabéns Dr. Luis, o melhor cirurgião plástico que eu pude conhecer 🙏 Deus abençoe grandemente.' },
  { id: '2', name: 'M.A.', source: 'Paciente', text: 'Feliz dia dos médicos! A você toda a minha gratidão por tudo que está fazendo pela Nicole. Que Deus continue abençoando seu profissionalismo, que você continue sendo esse médico dedicado à sua profissão, que faz a diferença na saúde de seus pacientes. Obrigada por tudo e por ter cruzado o nosso caminho e por fazer parte da vida da Nicole, trazendo alegria na vida dela. Há tempo eu não via ela tão feliz.' },
  { id: '3', name: 'A.R.', source: 'Paciente', text: 'Oii Luis. Nossa, eu fiquei muito feliz com o meu resultado!!!! Muito mesmo. Daqui uns anos, quando eu tiver filhos, eu vou procurar vocês pra me consertarem kkkkkkk. Deus abençoe muito vocês todos, são ótimos cirurgiões! No meu retorno faço questão de lembrar uma lembrança pra equipe.' },
  { id: '10', name: 'F.B.', source: 'Paciente', text: 'Estão lindas demais, doutor! 💛 As mamas ficaram perfeitas, do jeitinho que eu sonhava. O abdômen ainda não está no resultado final, mas já percebo que está melhorando a cada dia. Estou animada para dar sequência e fazer a ninfoplastia também, quero muito! 😍' },
  { id: '5', name: 'P.D.', source: 'Paciente', text: 'Que Deus te abençoe, doutor 🙏 você e sua família ❤️. Queria agradecer a forma que me tratou com muito respeito e carinho. Que Deus te abençoe imensamente, que Ele te dê em dobro tudo que você faz pelas pessoas. Obrigada 🙏❤️.' },
  { id: '8', name: 'L.M.', source: 'Paciente', text: 'Descansa em Deus e confia!!! Talento você tem ❤️. Sério, eu amei os meus seios ❤️. Do jeito… do tamanho!! Falo muito bem de você para as mulheradas. Mas enfim, muito obrigada por tudo!!! 😉' },
  { id: '1', name: 'L.S.', source: 'Paciente', text: 'Quero te agradecer de coração mesmo. O tanto que você é atencioso, profissional, talentoso nem se fala. Obrigada pela atenção de sempre, viu! E desculpa qualquer coisa! Você arrasa muito! 💙💙💙💙💙' },
  { id: '9', name: 'S.C.', source: 'Paciente', text: 'Obrigada, doutor. Deus abençoe muito sua vida!!!! Muito sucesso! Você é incrível!!!! Tudo de melhor para sua vida!!!!' },
  { id: '4', name: 'C.F.', source: 'Paciente', text: 'Boa sorte, doc! Com certeza será sucesso! Obrigada por tudo!!! Sou eternamente grata a tudo o que você me fez.' },
  { id: '6', name: 'T.P.', source: 'Paciente', text: 'Hoje tirei essas fotos 🥰. Aii, tô tão feliz. Muito obrigada, doutor, por me proporcionar essa realização.' },
  { id: '11', name: 'A.S.', source: 'Paciente', text: 'Obrigadaaaaaaa luissss! Meu sonho de anos completo e realizado. Deus abençoe ❤️' },
];

const TestimonialsSection: React.FC = () => {
  const autoScrollRef = useRef<any>(null);
  const [autoScrollPlugin, setAutoScrollPlugin] = useState<any[]>([]);

  useEffect(() => {
    import('embla-carousel-auto-scroll').then((mod) => {
      const plugin = mod.default({ speed: 1.2, stopOnInteraction: false, stopOnMouseEnter: false });
      autoScrollRef.current = plugin;
      setAutoScrollPlugin([plugin]);
    });
  }, []);

  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, align: 'start', dragFree: true },
    autoScrollPlugin
  );

  const scrollPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi]);
  const handleMouseEnter = useCallback(() => autoScrollRef.current?.stop(), []);
  const handleMouseLeave = useCallback(() => autoScrollRef.current?.play(), []);

  return (
    <section id="depoimentos" aria-labelledby="testimonials-title" className="section-spacing bg-dark-base relative overflow-hidden">
      <div className="absolute inset-0 gradient-glow" aria-hidden="true" />
      <div className="absolute bottom-0 left-1/3 w-[600px] h-[600px] decorative-blur decorative-blur-accent opacity-15" aria-hidden="true" />

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <AnimatedSection>
          <header className="text-center section-header-spacing">
            <h2 id="testimonials-title" className="text-3xl md:text-4xl lg:text-5xl text-light-primary mb-4 md:mb-8 leading-tight tracking-tight">
              O que meus <span className="text-gradient">pacientes dizem</span>
            </h2>
            <p className="text-base md:text-xl text-light-muted max-w-4xl mx-auto leading-relaxed">
              Relatos que refletem a experiência, o cuidado e o acompanhamento ao longo da jornada cirúrgica.
            </p>
          </header>
        </AnimatedSection>

        <AnimatedSection delay={150}>
          <div className="max-w-7xl mx-auto relative">
            <ul
              className="overflow-hidden -ml-5 list-none p-0 m-0"
              ref={emblaRef}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{
                maskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)',
                WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)',
              }}
            >
              <div className="flex" role="presentation">
                {testimonials.map((t) => (
                  <li
                    key={t.id}
                    className="flex-none w-[85%] sm:w-[48%] lg:w-[31%] pl-5 list-none"
                  >
                    <article className="card-surface">
                      <StarRating />
                      <blockquote className="card-desc">
                        <p>"{t.text}"</p>
                      </blockquote>
                      <footer className="pt-2 border-t border-white/8">
                        <p className="text-light-primary text-sm font-medium">{t.name}</p>
                        <span className="text-gold text-xs">{t.source}</span>
                      </footer>
                    </article>
                  </li>
                ))}
              </div>
            </ul>

            {/* Navigation buttons */}
            <nav aria-label="Navegação dos depoimentos" className="flex justify-center gap-3 mt-8">
              <button
                onClick={scrollPrev}
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 border border-white/10 text-light-primary flex items-center justify-center transition-all"
                aria-label="Depoimento anterior"
              >
                <span aria-hidden="true">‹</span>
              </button>
              <button
                onClick={scrollNext}
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 border border-white/10 text-light-primary flex items-center justify-center transition-all"
                aria-label="Próximo depoimento"
              >
                <span aria-hidden="true">›</span>
              </button>
            </nav>
          </div>
        </AnimatedSection>

        <p className="text-xs text-light-muted text-center mt-10 max-w-3xl mx-auto leading-relaxed italic">
          Os resultados podem variar conforme as características individuais de cada paciente.
        </p>
      </div>
    </section>
  );
};

export default TestimonialsSection;
